import {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import {
  useForm,
} from "react-hook-form";

import toast from "react-hot-toast";

import authService from "../../services/authService";

import styles from "./loginOtp.module.css";


export default function VerifyLoginOtp({
  login,
  onClose,
}) {
  const navigate = useNavigate();

  const [loading, setLoading] =
    useState(false);

  const [resendLoading, setResendLoading] =
    useState(false);


  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      otp: [
        "",
        "",
        "",
        "",
        "",
        "",
      ],
    },
  });


  // =====================================================
  // RESEND OTP
  // =====================================================

  const handleResendOtp = async () => {
    if (!login) return;

    try {
      setResendLoading(true);

      await authService.sendLoginOtp(login);

      toast.success(
        "OTP resent successfully"
      );
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Failed to resend OTP"
      );
    } finally {
      setResendLoading(false);
    }
  };


  // =====================================================
  // VERIFY OTP
  // =====================================================

  const onSubmit = async (data) => {
    if (!login) {
      toast.error(
        "Login information missing"
      );
      return;
    }

    const otp = data.otp.join("");

    if (otp.length !== 6) {
      toast.error(
        "Please enter 6 digit OTP"
      );
      return;
    }

    try {
      setLoading(true);

      await authService.verifyLoginOtp(
        login,
        otp
      );

      toast.success(
        "Login successful"
      );

      // Close popup
      if (onClose) {
        onClose();
      }

      // Stay on Home page
      navigate("/", {
        replace: true,
      });

      // Reload user/profile related UI
      window.dispatchEvent(
        new CustomEvent(
          "login-success"
        )
      );

    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Invalid OTP"
      );
    } finally {
      setLoading(false);
    }
  };


  // =====================================================
  // CLOSE POPUP
  // =====================================================

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };


  // =====================================================
  // OTP VALUES
  // =====================================================

  const otpValues =
    watch("otp");


  // =====================================================
  // NO LOGIN
  // =====================================================

  if (!login) {
    return null;
  }


  // =====================================================
  // UI
  // =====================================================

  return (
    <div
      className={styles.overlay}
      onClick={handleClose}
    >

      <div
        className={styles.modal}
        onClick={(e) =>
          e.stopPropagation()
        }
      >

        {/* CLOSE BUTTON */}

        <button
          type="button"
          className={styles.closeButton}
          onClick={handleClose}
          aria-label="Close"
        >
          ×
        </button>


        {/* LOGO */}

        <div className={styles.logo}>

          <img
            src="/vitauralogo.jpg"
            alt="Vitaura Logo"
            className={styles.logoImage}
          />

        </div>


        {/* TITLE */}

        <h4
          className={styles.title}
        >
          Verify OTP
        </h4>


        {/* OTP INFO */}

        <p
          className={styles.otpInfo}
        >
          OTP sent to{" "}
          <strong>
            {login}
          </strong>

          <span
            className={styles.link}
            onClick={() => {
              if (onClose) {
                onClose();
              }

              setTimeout(() => {
                window.dispatchEvent(
                  new CustomEvent(
                    "open-login-otp"
                  )
                );
              }, 0);
            }}
          >
            Change
          </span>
        </p>


        {/* FORM */}

        <form
          onSubmit={handleSubmit(
            onSubmit
          )}
        >

          {/* OTP INPUTS */}

          <div
            className={styles.inputGroup}
          >

            {otpValues.map(
              (_, index) => (
                <input
                  key={index}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  className={
                    styles.otpInput
                  }

                  {...register(
                    `otp.${index}`,
                    {
                      required: true,
                    }
                  )}

                  onInput={(e) => {
                    const value =
                      e.target.value;

                    if (
                      !/^\d*$/.test(
                        value
                      )
                    ) {
                      setValue(
                        `otp.${index}`,
                        ""
                      );

                      return;
                    }

                    setValue(
                      `otp.${index}`,
                      value
                    );

                    if (
                      value &&
                      e.target
                        .nextElementSibling
                    ) {
                      e.target
                        .nextElementSibling
                        .focus();
                    }
                  }}

                  onKeyDown={(e) => {
                    if (
                      e.key ===
                        "Backspace" &&
                      !otpValues[index] &&
                      e.target
                        .previousElementSibling
                    ) {
                      e.target
                        .previousElementSibling
                        .focus();
                    }
                  }}
                />
              )
            )}

          </div>


          {/* ERROR */}

          {errors.otp && (
            <p
              className={
                styles.error
              }
            >
              OTP is required
            </p>
          )}


          {/* VERIFY BUTTON */}

          <button
            type="submit"
            className={
              styles.button
            }
            disabled={loading}
          >

            {loading
              ? "Verifying OTP..."
              : "Verify OTP"}

          </button>


          {/* RESEND */}

          <div
            className={
              styles.resendContainer
            }
          >

            <span
              style={{
                color: "#666666",
              }}
            >
              Didn't receive OTP?{" "}
            </span>

            <button
              type="button"
              className={
                styles.resendButton
              }
              onClick={
                handleResendOtp
              }
              disabled={
                resendLoading
              }
            >
              {resendLoading
                ? "Resending..."
                : "Resend OTP"}
            </button>

          </div>

        </form>

      </div>

    </div>
  );
}